import { datadogRum } from '@datadog/browser-rum'
import {
  CookieConsentCustomSettings,
  browserScripts,
} from '@gousto-internal/storage-consent-web-package'

export const cookieBannerActions: CookieConsentCustomSettings = {
  onFirstConsent: () => {
    const hasConsentForDDTracking = browserScripts.hasConsent('Datadog')
    datadogRum.setTrackingConsent(hasConsentForDDTracking ? 'granted' : 'not-granted')
  },
  onConsentChange: () => {
    const hasConsentForDDTracking = browserScripts.hasConsent('Datadog')
    datadogRum.setTrackingConsent(hasConsentForDDTracking ? 'granted' : 'not-granted')
  },
}
